import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

const minHeight = 756;
const maxHeight = window.innerHeight - 100;

export const StripedDataGrid = styled(DataGrid)(() => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: '#7b818e08',
    },
    maxHeight: Math.max(minHeight, Math.min(maxHeight, window.innerHeight * 0.9)),
}));

export const BorderlessStripedDataGrid = styled(StripedDataGrid)(() => ({
        [`& .${gridClasses.row}.even`]: {
            backgroundColor: '#7b818e08',
        },
        minHeight,
        maxHeight: Math.max(minHeight, Math.min(maxHeight, window.innerHeight * 0.9)),
}))